import {FpAxios} from 'fp-components';
import {BaseFilter, DivisionFilter, FiltersResponse} from '@/models/Filter';
import Division, {DivisionDTO, DivisionKind, FinCRM_Division} from '@/models/Division';
import AuthService from '@/modules/user/AuthService';
import {AxiosInstance} from 'axios';
import FinCRM_User from '@/modules/adminPanel/services/FinCRM_User';
import {DivisionMember, DivisionMemberDTO} from '@/models/DivisionMember';
import processProxy from '@/env/processProxy';

class DivisionApi {
  private divisionAxios = FpAxios.create();
  readonly baseUrl = 'divisions';

  async filterDivisions(filters?: DivisionFilter): Promise<FiltersResponse<Division>> {
    if (AuthService.User!.isVerifier || !AuthService.User!.isUserOf.FINPACK) {
      filters!.organisationId = AuthService.User!.organisationId || null;
    }
    const response = await this.divisionAxios.post<FiltersResponse<Division>>(`${this.baseUrl}/search`, filters ? filters.apiData : {});
    return response.data;
  }

  async getMembersOfFilteredDivision(filters?: DivisionFilter): Promise<FiltersResponse<DivisionMember>> {
    if (AuthService.User!.isVerifier || !AuthService.User!.isUserOf.FINPACK) {
      filters!.organisationId = AuthService.User!.organisationId || null;
    }
    const response = await this.divisionAxios.post<FiltersResponse<DivisionMember>>(`${this.baseUrl}/search`, filters ? filters.apiData : {});
    response.data.items = response.data.items.map(
      (divisionMemberDto: DivisionMemberDTO) => new DivisionMember(divisionMemberDto));
    return response.data;
  }

  async fetchDivisionsChiefs(onlyMainChiefs: boolean = false) {
    const response = await this.divisionAxios.get(`${this.baseUrl}/chiefs?isMainChief=${onlyMainChiefs}`);
    return response.data;
  }

  async getDivisionKinds(): Promise<Array<DivisionKind>> {
    const response = await this.divisionAxios.get(`${processProxy.VUE_APP_OLD_BASE_URL}/organisations/api/divisiontypes`);
    return response.data;
  }

  async addDivision(division: FinCRM_Division): Promise<FinCRM_Division> {
    const response = await this.divisionAxios.post(`${processProxy.VUE_APP_OLD_BASE_URL}/organisations/api/organisations/${division.organisation?.id}/divisions`,
      division);
    return response.data;
  }

  async editDivision(division: FinCRM_Division): Promise<void> {
    await this.divisionAxios.patch(`${processProxy.VUE_APP_OLD_BASE_URL}/organisations/api/organisations/${division.organisationId}/divisions/${division.id}/fields`, division);
  }

  async getDivisionInfo(id: number): Promise<Division> {
    const response = await this.divisionAxios.get<Division>(`${this.baseUrl}/${id}`);
    return new Division(response.data);
  }

  async getDivisionsForUser(userId: number): Promise<Array<Division>> {
    const response = await this.divisionAxios.get<Array<Division>>(`${this.baseUrl}/user/${userId}`);
    return response.data;
  }

  async deleteDivision(organisationId: number, id: number): Promise<void> {
    await this.divisionAxios.delete(`${processProxy.VUE_APP_OLD_BASE_URL}/organisations/api/organisations/${organisationId}/divisions/${id}`);
  }

  async getDivisionsForLendiCare(): Promise<FinCRM_Division[]> {
    const response = await this.divisionAxios.get(`${processProxy.VUE_APP_OLD_BASE_URL}/organisations/api/organisations/lendi-care/networks`);
    return response.data;
  }
}

export default new DivisionApi();
